import { Observable } from 'rxjs';
import { BaseController } from '~client/controller/base-controller';
import { AccessibilityType } from '~client/model/accessibility-type';
import { DateFilterType } from '~client/model/date-filter-type';
import { UiUserActivityTabConfigurationResponse } from '~client/model/ui-user-activity-tab-configuration-response';
import { UserActivityEventDetailResponse } from '~client/model/user-activity-event-detail-response';
import { UserActivityEventListResponse } from '~client/model/user-activity-event-list-response';
import { UserActivityListSummaryResponse } from '~client/model/user-activity-list-summary-response';
import { UserEventVideoStreamInfoResponse } from '~client/model/user-event-video-stream-info';

export class UserActivityController extends BaseController {
  /**
   * Returns list of user activity for attending events
   * @param categoryAccessibilityType
   * @param dateFilterType
   */
  public getUserActivityAttendingEventList(
    categoryAccessibilityType: AccessibilityType,
    dateFilterType: DateFilterType,
  ): Promise<UserActivityEventListResponse> {
    return this.get('/user/activityList/attendingEventList', {
      categoryAccessibilityType,
      dateFilterType,
    });
  }

  /**
   * Returns list of user activity for requested events
   * @param dateFilterType
   */
  public getUserActivityActiveOfferList(
    dateFilterType: DateFilterType,
  ): Promise<UserActivityEventListResponse> {
    return this.get('/user/activityList/activeOfferEventList', { dateFilterType });
  }

  /**
   * Returns list of user activity summaries for all events
   * @param eventIds
   */
  public getUserActivityListSummary(eventIds: number[]): Promise<UserActivityListSummaryResponse> {
    return this.get('/user/activityList/summary', { eventIds });
  }

  /**
   * @deprecated
   * Returns user activity for a given event
   * if you don't have event details, this is what you should be calling.
   * @param eventId
   */
  public getUserActivityDetails$(eventId: string): Observable<UserActivityEventDetailResponse> {
    return this.get$('/user/activity', { eventId });
  }

  /**
   * Returns user activity for a given event
   * @param eventId
   */
  public getUserActivityDetails(eventId: string): Promise<UserActivityEventDetailResponse> {
    return this.get('/user/activity', { eventId });
  }

  /**
   * Returns user activity summary for a given event
   * this endpoint is meant to complement event details, it does not contain any event details
   * @param eventId
   */
  public getUserActivitySummary(eventId: string): Promise<UserActivityEventDetailResponse> {
    return this.get('/user/activity/summary', { eventId });
  }

  /**
   * @deprecated use non-observable instead.
   * Returns user activity summary for a given event
   * @param eventId
   */
  public getUserActivitySummary$(eventId: string): Observable<UserActivityEventDetailResponse> {
    return this.get$('/user/activity/summary', { eventId });
  }

  /**
   * Returns an array of tab configurations for My Yoop
   */
  public getUserActivityTabConfiguration(): Promise<UiUserActivityTabConfigurationResponse> {
    return this.get('/user/activityConfiguration');
  }

  /**
   * Returns streaming related information for a given event
   * @param eventId
   * @deprecated
   */
  public getUserEventVideoStreamInfo(eventId: string): Promise<UserEventVideoStreamInfoResponse> {
    return this.get('/user/videoStreamInfo', { eventId, platform: 'WEB' });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/controller/user-activity-controller.ts